// extracted by mini-css-extract-plugin
module.exports = {"teaserGrid":"TeaserGrid-module--teaserGrid--1MiwZ","title":"TeaserGrid-module--title--2UpLI","storyGrid":"TeaserGrid-module--storyGrid--1qPE-"};